import React, { useState, useEffect, useRef, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Divider,
  Card,
  CardContent,
  Box,
  Alert,
  Button,
  Paper,
} from "@mui/material";
import FaceVerification from "./assests/FaceVerification.svg";
import { IoIosInformationCircleOutline } from "react-icons/io";
import pages from "../../constants/pages";
import { OuterBox, LoadingButton, SubheaderSection } from "../../components";
import Webcam from "react-webcam";
import { useAxios } from "../../hooks";
import UserStatus from "../Liveliness/UserStatus";
import AwsUpload from "../../utils/AwsUpload";
import { styled } from "@mui/material/styles";

const OuterBox2 = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  background: #ffffff;
`;

const OuterPaper = styled(Paper)`
  width: 100%;
  padding: 0px 20px 20px;
  min-height: 20vh;
`;

const OuterPaper2 = styled(Paper)`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
  border-radius: 15px;
  position: relative;
`;

export default function UploadDocument() {
  const axios = useAxios();
  const navigate = useNavigate();
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [capturing, setCapturing] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [mimeType, setMimeType] = useState("video/webm;codecs=vp8,opus");
  const [startRecording, setStartRecording] = useState(false);
  const [cameraError, setCameraError] = useState(null);
  const [streamReady, setStreamReady] = useState(false);
  const [userStatus, setUserStatus] = useState(false);
  const [userData, setUserData] = useState({});

  const [countdown, setCountdown] = useState(0);
  const [recordingTime, setRecordingTime] = useState(0);

  const timerRef = useRef(null);
  const countdownRef = useRef(null);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const location = useLocation();
  const { visitor_id } = location.state || {};

  const queryParams = new URLSearchParams(location.search);

  const bookingId = queryParams.get("booking_id");
  const visitorId = queryParams.get("visitor_id");
  const popup = queryParams.get("popup");
  const doc_face = queryParams.get("doc_face");
  const entityId = queryParams.get("entity_id");
  const userTypeId = queryParams.get("user_type_id");
  const autoConsent = queryParams.get("auto_consent");
  const fromPreview = queryParams.get("from_preview");
  const indepentent = queryParams.get("indepentent");

  // Detect OS and set mimeType
  useEffect(() => {
    if (navigator.userAgent.includes("Windows")) {
      setMimeType("video/webm;codecs=vp8,opus");
    } else if (navigator.userAgent.includes("Mac OS")) {
      setMimeType("video/mp4");
    } else {
      setMimeType("video/webm;codecs=vp8,opus");
    }
  }, []);

  const handleUserMedia = (stream) => {
    console.log("✅ Stream ready:", stream);
    console.log("Video tracks:", stream.getVideoTracks());
    console.log("Audio tracks:", stream.getAudioTracks());
    setStreamReady(true);
    setCameraError(null);
  };

  const handleUserMediaError = (err) => {
    console.error("❌ Stream error:", err);
    console.error("Error name:", err.name);
    console.error("Error message:", err.message);
    setStreamReady(false);

    let errorMessage = "Unable to access camera. ";

    if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
      errorMessage +=
        "Camera not found - but it works in other tabs, so this might be a constraint issue.";
    } else if (
      err.name === "NotAllowedError" ||
      err.name === "PermissionDeniedError"
    ) {
      errorMessage += "Permission denied. Please allow camera access.";
    } else if (
      err.name === "NotReadableError" ||
      err.name === "TrackStartError"
    ) {
      errorMessage += "Camera already in use.";
    } else if (err.name === "OverconstrainedError") {
      errorMessage +=
        "Camera constraints not supported. Try removing videoConstraints.";
    } else {
      errorMessage += `${err.name}: ${err.message}`;
    }

    setCameraError(errorMessage);
  };

  const startRecordingProcess = () => {
    setCapturing(true);
    setRecordingTime(0);

    timerRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);

    // your existing recording start logic here...
  };

  const handleStartCapture = () => {
    if (!streamReady) {
      alert("Please wait for the camera to initialize.");
      return;
    }

    setCountdown(5); // start 3-second countdown

    let counter = 5;
    countdownRef.current = setInterval(() => {
      counter -= 1;
      if (counter > 0) {
        setCountdown(counter);
      } else {
        clearInterval(countdownRef.current);
        setCountdown(0);
        startRecordingProcess();
      }
    }, 1000);

    setCapturing(true);
    setRecordedChunks([]);

    let stream =
      webcamRef.current?.stream || webcamRef.current?.video?.srcObject;

    if (!stream) {
      console.error("No MediaStream found", webcamRef.current);
      alert("Unable to access camera stream. Please refresh and try again.");
      setCapturing(false);
      return;
    }

    try {
      const supportedMimeType = MediaRecorder.isTypeSupported(mimeType)
        ? mimeType
        : "video/webm";

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: supportedMimeType,
      });
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.addEventListener("dataavailable", handleDataAvailable);
      mediaRecorder.start();

      console.log("🎥 Recording started with mimeType:", supportedMimeType);
      setTimeout(() => {
        console.log("handleStopCapture");

        handleStopCapture();
        console.log("handleSave");
        // handleSave();
        console.log("ooh");
      }, 5000);
    } catch (err) {
      console.error("Error starting MediaRecorder:", err);
      alert("Recording not supported on this device/browser.");
      setCapturing(false);
    }
  };

  const handleDataAvailable = (e) => {
    if (e.data.size > 0) {
      setRecordedChunks((prev) => prev.concat(e.data));
    }
  };

  const handleStopCapture = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      mediaRecorderRef.current.stop();
    }
    setCapturing(false);
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  useEffect(() => {
    if (recordedChunks.length) {
      handleSave();
    }
  }, [recordedChunks]);
  const handleSave = async () => {
    if (recordedChunks.length) {
      setLoading(true);
      const blob = new Blob(recordedChunks, { type: mimeType });
      const fileurl = await AwsUpload(blob, "video");
      axios({
        url: "/event/verify/find-face",
        method: "POST",
        data: {
          img_base64: "",
          liveliness_check: "active",
          video_url: fileurl,
        },
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (!response.status) {
          !response.data.eye_blink_count
            ? setUserData(response.data)
            : setUserData({
                message: response.data.message || response.displayMessage,
              });

          setUserStatus(true);
          setLoading(false);
        } else {
          setLoading(false);

          let key = visitorId;

          localStorage.setItem(key, response.data.encrypted_face_data);

          if (doc_face == false) {
            axios({
              url: "event/verify/face",
              method: "POST",
              data: {
                // doc_face_image: userDocData?.doc_face_image,
                // captured_face_image: imageDataURLSend.replace(
                //   /^data:image\/[a-z]+;base64,/,
                //   ""
                // ),
              },
            }).then((response) => {
              if (response.status) {
                navigate(
                  pages.previewLivelinessVideo.route +
                    `?visitor_id=${
                      visitor_id || visitorId || ""
                    }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}${
                      popup ? "&popup=" + popup : ""
                    }&auto_consent=${autoConsent}${
                      indepentent ? "&indepentent=" + indepentent : ""
                    }`,

                  {
                    state: {
                      blob,

                      clickPhotoURL: location.pathname + location.search,

                      popup: popup || "",
                    },
                    replace: false,
                  }
                );
              }
            });
          } else {
            navigate(
              pages.previewLivelinessVideo.route +
                `?visitor_id=${
                  visitor_id || visitorId || ""
                }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}${
                  popup ? "&popup=" + popup : ""
                }&auto_consent=${autoConsent}${
                  indepentent ? "&indepentent=" + indepentent : ""
                }`,
              {
                state: {
                  blob,

                  clickPhotoURL: location.pathname + location.search,
                  popup: popup || "",

                  docFace: doc_face || "",
                },
                replace: false,
              }
            );
          }
        }
      });
    }
  };

  const verificationContent = startRecording
    ? ""
    : "Next, Please read the following guidelines then proceed to Liveness Check:";

  return (
    <Fragment>
      {/* --- HERO SECTION --- */}
      {!startRecording && (
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <OuterBox2>
              <OuterPaper sx={{ p: 0 }} elevation={3}>
                <Box
                  sx={{
                    width: "100%",
                    position: "relative",
                    height: { xs: "200px", sm: "280px", md: "35vh" },
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      top: "50%",
                      left: "2%",
                      transform: "translateY(-50%)",
                      pt: 10,
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontWeight={900}
                      sx={{
                        marginTop: "7.5px",
                        fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" },
                      }}
                    >
                      Identity Verification
                      <Tooltip title="Instruction">
                        <IoIosInformationCircleOutline
                          style={{
                            verticalAlign: "middle",
                            color: "#AAA9F3",
                            marginLeft: "6px",
                          }}
                        />
                      </Tooltip>
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={500}
                      sx={{
                        marginTop: "7.5px",
                        color: "#00000099",
                        pr: { xs: 2, sm: 4 },
                      }}
                    >
                      Please complete the following steps to verify your
                      identity.
                    </Typography>
                  </Grid>
                  <img
                    src={FaceVerification}
                    alt="Face Verification"
                    style={{
                      height: "100%",
                      position: "absolute",
                      top: 0,
                      maxWidth: "50%",
                      objectFit: "contain",
                      left: 0,
                    }}
                  />
                </Box>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      )}

      {/* --- MAIN BODY --- */}
      <form style={{ ...(startRecording && { height: "100%" }) }}>
        {!startRecording ? (
          <Grid container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <OuterBox2>
                <OuterPaper sx={{ p: { xs: 4, sm: 5, md: 6 } }} elevation={3}>
                  {/* --- STEPS SECTION --- */}
                  <Grid
                    container
                    sx={{
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      mb: 4,
                    }}
                  >
                    <Divider sx={{ background: "#0000001A", width: "20%" }} />
                    <Typography
                      variant="h6"
                      fontWeight={500}
                      sx={{
                        textAlign: "center",
                        color: "#00000080",
                        mx: 1,
                      }}
                    >
                      Steps
                    </Typography>
                    <Divider sx={{ background: "#0000001A", width: "20%" }} />
                  </Grid>

                  {/* --- INSTRUCTION LIST --- */}
                  <Grid container spacing={2}>
                    {[
                      {
                        title: "Face ID Verification",
                        description:
                          "Capture a selfie for facial recognition. Enable camera, mic & location, keep your face in frame with good lighting, and use live video.",
                      },
                      {
                        title: "Choose a Verification Document",
                        // description: "Select one of the following:",
                        subItems: ["Aadhaar", "Driving License", "Passport"],
                      },
                      {
                        title: "Identity Matching",
                        description:
                          "We will match your name and Face ID with your selected government-issued document.",
                      },
                      {
                        title: "Consent & Privacy Declaration",
                        description:
                          "Review and accept the privacy policy and terms of consent.",
                      },
                      {
                        title: "Confirmation",
                        description:
                          "Receive confirmation upon successful verification.",
                      },
                    ].map((item, idx) => (
                      <Grid item xs={12} sm={6} key={idx}>
                        <Card
                          variant="outlined"
                          sx={{
                            height: "100%",
                            borderColor: "white",
                            boxShadow: "none !important",
                          }}
                        >
                          <CardContent
                            sx={{
                              p: { xs: 0, sm: 0 },
                              "&:last-child": { pb: 0 },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                // mb: 1,
                              }}
                            >
                              <Typography
                                variant="body1"
                                fontWeight={500}
                                sx={{ minWidth: "24px" }}
                              >
                                {`${idx + 1}.`}
                              </Typography>
                              <Box sx={{ ml: 1 }}>
                                <Typography variant="body1" fontWeight={800}>
                                  {item.title}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ mt: 0.5 }}
                                >
                                  {item.description}
                                </Typography>
                                {item.subItems && (
                                  <ul
                                    style={{
                                      margin: "4px 0 0 16px",
                                      padding: 0,
                                    }}
                                  >
                                    {item.subItems.map((subItem, subIdx) => (
                                      <li key={subIdx}>
                                        <Typography
                                          variant="body2"
                                          color="text.secondary"
                                        >
                                          {subItem}
                                        </Typography>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>

                  <LoadingButton
                    onClick={() => {
                      setStartRecording(true);
                    }}
                    fullWidth
                    style={{ marginTop: "15px", py: 1.5, boxShadow: "none" }}
                  >
                    Start Verification
                  </LoadingButton>
                </OuterPaper>
              </OuterBox2>
            </Grid>
          </Grid>
        ) : (
          /* --- CAMERA VIEW --- */
          <Grid item container justifyContent="center">
            <Grid item xs={12} md={10} lg={8}>
              <OuterBox2>
                <OuterPaper2 elevation={3}>
                  {cameraError && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {cameraError}
                    </Alert>
                  )}

                  {/* <Webcam
                    ref={webcamRef}
                    audio={false}
                    onUserMedia={handleUserMedia}
                    onUserMediaError={handleUserMediaError}
                    style={{
                      // borderRadius: "10px",
                      width: "100%",
                      height: "72vh",
                      objectFit: "cover",
                    }}
                  /> */}

                  <Box sx={{ position: "relative", width: "100%" }}>
                    <Webcam
                      ref={webcamRef}
                      audio={false}
                      onUserMedia={handleUserMedia}
                      onUserMediaError={handleUserMediaError}
                      style={{
                        width: "100%",
                        height: "85vh",
                        objectFit: "fill",
                        // borderRadius: "10px",
                      }}
                      videoConstraints={{ width: 480, height: 640 }}
                    />
                    <Grid
                      item
                      xs={12}
                      display={"flex"}
                      justifyContent={"center"}
                      style={{
                        position: "absolute",
                        // bottom: "70px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        top: "8vh",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 361 361"
                        fill="none"
                        style={{
                          width: "100%",
                          height: "auto",
                          maxWidth: "329px",
                          display: "block",
                        }}
                      >
                        <circle
                          cx="180.5"
                          cy="180.5"
                          r="180"
                          stroke="transparent"
                          stroke-opacity="0.9395"
                        />
                      </svg>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="60"
                        viewBox="0 0 28 28"
                        fill="none"
                      >
                        <path
                          d="M2 8.88254V8.70607C2 5.00252 5.00232 2.0002 8.70587 2.0002V2.0002"
                          stroke="white"
                          stroke-width="1.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2 19.1179V19.2943C2 22.9979 5.00232 26.0002 8.70587 26.0002V26.0002"
                          stroke="white"
                          stroke-width="1.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M25.8232 8.88254V8.70607C25.8232 5.00252 22.8209 2.0002 19.1174 2.0002V2.0002"
                          stroke="white"
                          stroke-width="1.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M25.8232 19.1179V19.2943C25.8232 22.9979 22.8209 26.0002 19.1174 26.0002V26.0002"
                          stroke="white"
                          stroke-width="1.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M18.8806 19.0522V19.0522C16.3528 20.1757 13.4673 20.1757 10.9395 19.0522V19.0522"
                          stroke="#3936EF"
                          stroke-opacity="0.4"
                          stroke-width="1.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M15.435 10.2287V14.0164C15.435 15.0128 14.7379 15.8733 13.7632 16.0801V16.0801"
                          stroke="#3936EF"
                          stroke-opacity="0.4"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9.88086 10.2287L9.88086 12.3185"
                          stroke="#3936EF"
                          stroke-opacity="0.4"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M20.1162 10.2287L20.1162 12.3185"
                          stroke="#3936EF"
                          stroke-opacity="0.4"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M17.8816 19.0526V19.0526C15.3537 20.1761 12.4683 20.1761 9.94043 19.0526V19.0526"
                          stroke="white"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M14.436 10.2291V14.0168C14.436 15.0132 13.7389 15.8737 12.7642 16.0805V16.0805"
                          stroke="white"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M8.88184 10.2291L8.88184 12.3189"
                          stroke="white"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                        <path
                          d="M19.1172 10.2291L19.1172 12.3189"
                          stroke="white"
                          stroke-width="2.4"
                          stroke-linecap="round"
                        />
                      </svg>
                      <Typography
                        variant="h5"
                        style={{
                          fontWeight: "900",
                          color: "white",
                          margin: "5px 0px",
                        }}
                      >
                        Face Verification Initiated...
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: "900",
                          color: "white",
                          margin: "5px 0px",
                        }}
                      >
                        Please verify the image before submitting
                      </Typography>

                      {!capturing ? (
                        <LoadingButton
                          id="click-photo"
                          type="button"
                          loading={loading}
                          style={{
                            padding: "10px 45px",
                            width: "95%",
                            boxShadow: "none",
                            // marginTop: buttonMargin,
                          }}
                          variant="contained"
                          onClick={handleStartCapture}
                        >
                          {streamReady
                            ? "Start Recording"
                            : "Waiting for camera..."}
                        </LoadingButton>
                      ) : (
                        <LoadingButton
                          id="click-photo"
                          type="button"
                          loading={loading}
                          style={{
                            padding: "10px 45px",
                            width: "95%",
                            boxShadow: "none",
                            // marginTop: buttonMargin,
                          }}
                          variant="contained"
                          onClick={handleStopCapture}
                        >
                          Stop Recording
                        </LoadingButton>
                      )}
                    </Grid>

                    {/* 3-2-1 Countdown Overlay */}
                    {countdown > 0 && (
                      <Typography
                        variant="h2"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          background: "rgba(0,0,0,0.5)",
                          color: "#fff",
                          px: 4,
                          py: 2,
                          borderRadius: "50%",
                          fontWeight: 700,
                          animation: "scaleUp 1s ease",
                          "@keyframes scaleUp": {
                            from: {
                              transform: "translate(-50%, -50%) scale(0.5)",
                              opacity: 0,
                            },
                            to: {
                              transform: "translate(-50%, -50%) scale(1)",
                              opacity: 1,
                            },
                          },
                        }}
                      >
                        {countdown}
                      </Typography>
                    )}
                  </Box>
                </OuterPaper2>
              </OuterBox2>
            </Grid>
          </Grid>
        )}
      </form>

      <UserStatus
        userStatus={userStatus}
        setUserStatus={setUserStatus}
        setUserData={setUserData}
        userData={userData}
      />
    </Fragment>
  );
}
